<div class="toast-container">
  @for (notification of notifications(); track notification) {
    <app-toast [notification]="notification"></app-toast>
  }
</div>
